import { render, staticRenderFns } from "./studentsWithdraw.vue?vue&type=template&id=657a013e&scoped=true&"
import script from "./studentsWithdraw.vue?vue&type=script&lang=js&"
export * from "./studentsWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./studentsWithdraw.vue?vue&type=style&index=0&id=657a013e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a013e",
  null
  
)

export default component.exports